[
  {
    "code": "GQ-C",
    "name": "Región Continental"
  },
  {
    "code": "GQ-I",
    "name": "Región Insular"
  }
]